import { AxiosInstance } from 'axios';
import { inject, injectable, named } from 'inversify';

import { BAAS_AXIOS_INSTANCE_TYPES, BAAS_TYPES, BaasAppState, BaasLogOffHook, checkLocalhost } from '@lvflanders/bar';

const STARTSCHERM_WEB_API_URL_SEGMENT = '/startscherm/domain.startscherm.web/';

// NOTE uses Inversify and not Angular !
@injectable()
export class StartschermLogOffHook implements BaasLogOffHook {
    get #rootUrl() {
        if (checkLocalhost()) return this.appState.location.release.origin + STARTSCHERM_WEB_API_URL_SEGMENT;
        return location.origin + STARTSCHERM_WEB_API_URL_SEGMENT;
    }

    constructor(
        @inject(BAAS_TYPES.AxiosInstance) @named(BAAS_AXIOS_INSTANCE_TYPES.Baas) private axios: AxiosInstance,
        @inject(BaasAppState) private appState: BaasAppState
    ) {}

    async run(): Promise<void> {
        await this.axios.post<void>(`${this.#rootUrl}Home/Afmelden`, null, { params: { isMvc: false } });
    }
}
